module.exports = __webpack_public_path__ + "img/welding-10.2890e5d0.jpg";